import { NotificationItemBody } from "~pages/Notifications/components/NotificationItemBody.tsx";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

export const DefaultNotificationItem = ({ notification }: Props) => {
  return <NotificationItemBody notification={notification} icon="fa-circle-exclamation" />;
};
